import { getWebsiteTypeOptions } from "app/common/keyword-research/search-competitors/websiteTypeOptions";
import { translate } from "app/filters/i18nFilter";
import type React from "react";
import { EllipsisDropdownItem, ChipDownContainer } from "@similarweb/ui-components";
import { useKeywordCompetitorsPageContext } from "app/pages/keyword-research/website-analysis/pages/search-competitors/KeywordCompetitorsPageContext";
export const WebsiteTypeFilter: React.FC = () => {
    const websiteTypeItems = getWebsiteTypeOptions().map((websiteType) => {
        return (
            <EllipsisDropdownItem
                key={websiteType.text}
                id={websiteType.id}
                tooltipText={translate(websiteType.tooltipText)}
                text={translate(websiteType.text)}
            >
                {translate(websiteType.text)}
            </EllipsisDropdownItem>
        );
    });
    const { onSelectWebsiteType, selectedWebsiteType } = useKeywordCompetitorsPageContext();
    const selectedText =
        selectedWebsiteType && getWebsiteTypeOptions().find((type) => type.id === selectedWebsiteType).text;
    const selectedIds = selectedWebsiteType ? { [selectedWebsiteType]: true } : {};
    return (
        <ChipDownContainer
            width={280}
            hasSearch={false}
            selectedIds={selectedIds}
            selectedText={translate(selectedText)}
            buttonText={translate("analysis.source.search.keywords.filters.websitetype")}
            onClick={onSelectWebsiteType}
            onCloseItem={() => onSelectWebsiteType(null)}
            noResultsMessage={translate("dropdown.no.results")}
        >
            {websiteTypeItems}
        </ChipDownContainer>
    );
};
